import BulkOrderItemsShowPage from '../../../components/pages/bulk_order/items/BulkOrderItemsShowPage.vue'
export default {
  components: {
    BulkOrderItemsShowPage
  }
}
